const get = key => obj => obj[key];

export default get;